import React from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/index.css";
import "./assets/css/header.css";
import "./assets/css/sidebar.css";
import "./assets/css/search.css";
import "./assets/css/responsive.css";
import GoogleMapContainer from "./components/GoogleMapContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  setLeadStatusOptions,
  setListings,
  setListView,
  setLogged,
  setSelectedListing,
  setTeamFeatures,
  setUserData,
  setUserFavoritesData,
  setUserRemindersData,
  setUserType,
} from "./store/reducers/listingReducer";
import {
  callLogout,
  getLeadStatusOptions,
  getListingData,
  getTeamFeatures,
  getUserFavorites,
  getUserReminders,
  verifyToken,
} from "./services/api";
import { getToken } from "./helpers/util";
import {
  Outlet,
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import Header from "./components/Header";
import axios from "axios";
import { useMediaQuery } from "@uidotdev/usehooks";
import { GoogleMaps } from "./components/Maps";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isSmallScreen = useMediaQuery("(max-width: 640px)");

  const selectedListing = useSelector(
    (state: any) => state.listingReducer.selectedListing
  );
  const listings = useSelector((state: any) => state.listingReducer.listings);
  const favoritesShow = useSelector(
    (state: any) => state.listingReducer.favoritesShow
  );
  const remindersShow = useSelector(
    (state: any) => state.listingReducer.remindersShow
  );
  const routesShow = useSelector(
    (state: any) => state.listingReducer.routesShow
  );
  const [loading, setLoading] = React.useState<boolean>(true);
  const logged = useSelector((state: any) => state.listingReducer.logged);
  const teamActivityShow = useSelector(
    (state: any) => state.listingReducer.teamActivityShow
  );
  const listView = useSelector((state: any) => state.listingReducer.listView);
  const mapCenter = useSelector((state: any) => state.listingReducer.mapCenter);
  const mapZoom = useSelector((state: any) => state.listingReducer.mapZoom);
  const refetch = useSelector((state: any) => state.listingReducer.refetch);
  const appType = useSelector((state: any) => state.listingReducer.appType);

  const isCommercialDomain = useSelector(
    (state: any) => state.listingReducer.isCommercial
  );

  let { listingId } = useParams();
  const navigate = useNavigate();

  /*React.useEffect(() => {
    const isCommercialPath = location.pathname.startsWith("/commercial");
    console.log("load commercial", isCommercialDomain);
    if (isCommercialDomain && !isCommercialPath) {
      navigate("/commercial");
    }
  }, []);*/

  React.useEffect(() => {
    (async () => {
      let leadStatusOptionsResponse = await getLeadStatusOptions();
      dispatch(setLeadStatusOptions(leadStatusOptionsResponse.data.data));
    })();

    return () => {};
  }, []);

  const getQueryType = (type: string) => {
    if (appType === "commercial") {
      return "is_commercial=1";
    } else if (appType === "investment") {
      return "is_investment=1";
    }
    return "";
  };

  React.useEffect(() => {
    const cancelToken = axios.CancelToken.source();
    let fetchData = true;
    (async () => {
      try {
        let listingResponse = await getListingData(
          cancelToken.token,
          mapCenter,
          mapZoom,
          "",
          getQueryType(appType)
        );
        if (fetchData) {
          dispatch(setListings(listingResponse.data.data));
        }
        setLoading(false);
      } catch (error) {
        if (axios.isCancel(error)) {
          //console.log('Request canceled:', error.message);
        } else {
          //console.error('An error occurred:', error);
        }
      }
    })();

    return () => {
      fetchData = false;
      cancelToken.cancel("Component unmounted, request canceled");
    };
  }, [logged, mapCenter, mapZoom, refetch]);

  React.useEffect(() => {
    (async () => {
      if (logged) {
        let userRemindersResponse = await getUserReminders();
        if (userRemindersResponse) {
          dispatch(setUserRemindersData(userRemindersResponse.data.data));
        }
      }
    })();

    return () => {};
  }, [logged]);

  React.useEffect(() => {
    (async () => {
      if (logged) {
        let userFavoriteResponee = await getUserFavorites();
        if (userFavoriteResponee) {
          dispatch(setUserFavoritesData(userFavoriteResponee.data.data));
        }
      }
    })();

    return () => {};
  }, [logged]);

  React.useEffect(() => {
    (async () => {
      if (logged) {
        let teamFeatures = await getTeamFeatures();
        if (teamFeatures) {
          //console.log(teamFeatures.data.data?.features);
          if (
            teamFeatures.data.data?.features &&
            teamFeatures.data.data?.features !== ""
          ) {
            dispatch(
              setTeamFeatures(JSON.parse(teamFeatures.data.data?.features))
            );
          }
        }
      }
    })();

    return () => {};
  }, [logged]);

  React.useEffect(() => {
    if (listingId && listingId !== "") {
      dispatch(setSelectedListing(listingId));
    } else {
      dispatch(setSelectedListing(null));
    }
  }, [listingId]);

  /*React.useEffect(() => {
          if (selectedListing !== null && listings.length > 0) {
              let item = getSelectedListing()
              setCurrentListing(item)
          }
      }, [selectedListing, listings]);*/

  /*React.useEffect(() => {
          const handleInvalidToken = () => {
              // help us to logout current and other tabs
              if (checkAuth()) {
                  logout()
              }
          }
          (window as any).addEventListener('storage', handleInvalidToken);
          return function cleanup() {
              window.removeEventListener('storage', handleInvalidToken)
          }
      }, []);*/

  React.useEffect(() => {
    (async () => {
      try {
        if (getToken()) {
          let tokenResponse = await verifyToken(
            localStorage.getItem("listings-app-api-token")
          );
          if (tokenResponse) {
            dispatch(setUserType(tokenResponse.data.user_type));
            dispatch(setUserData(tokenResponse.data));
            dispatch(setLogged(true));
          }
        } else {
          logout();
        }
      } catch (error) {
        logout();
      } finally {
      }
    })();

    return () => {};
  }, []);

  const logout = async () => {
    await callLogout();
    dispatch(setUserData(null));
    dispatch(setLogged(false));
    //window.location.reload();
    return true;
  };

  function handleListView() {
    dispatch(setListView(true));
  }

  const MemoizedHeader = React.memo(Header);

  return (
    <div>
      {loading && (
        <div className="ki-loading-container">
          <div className="ki-loading-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <MemoizedHeader />
      <div
        className={`md:grid md:grid-rows-1 ${
          loading ? "grid-cols-1" : "grid-cols-[61%_39%]"
        } min-h-[calc(100vh_-_125.5px)] mt-[9rem] hidden`}
      >
        <div>
          {/* <GoogleMapContainer /> */}
          <GoogleMaps />
        </div>

        {!loading ? (
          <div className="h-[calc(100vh_-_125.5px)] overflow-auto">
            <Outlet />
          </div>
        ) : null}
      </div>

      {isSmallScreen ? (
        <div className="grid grid-rows-[30rem_50%] min-h-[calc(100vh_-_64px)] mt-[4.5rem] overflow-auto md:hidden">
          <div className={location.pathname === "/" ? "block" : "hidden"}>
            <GoogleMapContainer />
          </div>

          <div className="">
            <Outlet />
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default App;
